import useWaitingMutation from '@common/hooks/useWaitingMutation';
import { completeRetireDocument } from '@common/services/submissionService';
import { ISelectOption, DocumentType } from '@common/types';

export const queryKey = 'softDeleteContentDetailsData';

export interface ISoftDeleteArgs {
  reason: ISelectOption;
}

export const useCompleteRetireDocument = (submissionId: number, documentId: number, documentType: DocumentType) => {
  const { mutate } = useWaitingMutation(({ reason }: ISoftDeleteArgs) => {
    return completeRetireDocument(submissionId, documentId, documentType, {
      reasonId: reason.id,
      reason: reason.value,
    });
  });

  return { completeRetireDocument: mutate };
};
